<template lang="html">
	<div class="custom-select solo">
		<div class="selected row" @click.stop="display()">
			<div class="content-select row" v-if="select">
				<div class="ctn-profile-picture" v-if="select.firstname || select.first_name">
					<img v-img-detect :src="getPicture(select)" alt="">
				</div>
				<span v-if="select.firstname || select.first_name" :title="(select.firstname || select.first_name) + ' ' + (select.lastname || select.last_name)">{{ select.firstname || select.first_name }} {{ select.lastname || select.last_name }}</span>
				<span v-else>-</span>
			</div>
			<div class="v-else">
				&nbsp;
			</div>
			<span class="icon-arrow-full-down" :class="{deploy: show}" v-if="!innerDisabled"></span>
		</div>
		<div class="items" v-if="show">
			<div class="item row" v-for="(client, key) in items" v-bind:key="key" @click.stop="setSelect(key)">
				<div class="ctn-profile-picture" v-if="client !== '-'">
					<img v-img-detect :src="getPicture(client)" alt="">
				</div>
				<span>{{ client.firstname || '-' }} {{ client.lastname }}</span>
			</div>
		</div>
	</div>
</template>

<script>
/*
 For now it support several things :
 v-model and default selected / change emit
 but for the well being of validation I started to
 make change into v-model value
*/
export default {
	name: 'custom-select-user',
	props: ['value', 'items', 'disabled'],
	data () {
		return {
			select: null,
			show: false,
			innerDisabled: false
		}
	},
	mounted () {
		this.select = this.items[0]
		if (this.value) {
			this.select = this.value || this.items[0]
		}
		this.$emit('input', this.select)
		this.innerDisabled = this.disabled
	},
	methods: {
		setSelect (key) {
			this.select = this.items[key]
			this.show = false
			this.$emit('input', this.select)
		},
		display () {
			if (!this.innerDisabled) {
				this.show = !this.show
				if (this.show) {
					window.addEventListener('click', this.checkClick)
				}
			}
		},
		checkClick (e) {
			this.show = false
			window.removeEventListener('click', this.checkClick)
		},
		getPicture (client) {
			if (client) {
				return (client.media && client.media.file) ? process.env.ASSETS_ROOT + client.media.file : process.env.API_ROOT + '/assets/user.png'
			} else {
				return null
			}
		}
	},
	watch: {
		items () {
			if (!this.select) this.select = this.items[0]; this.$emit('input', this.select)
		},
		value () {
			this.select = this.value
		},
		disabled () {
			if (this.disabled) {
				this.innerDisabled = true
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.selected {
	justify-content: flex-start;

	.content-select {
		justify-content: flex-start;
		align-items: center;

		.ctn-profile-picture {
			width: 1.5rem;
			height: 1.5rem;
			border: none;
			margin-right: 0.5rem;
		}

		span {
			color: #696969;
			position: inherit;
			top: inherit;
			transform: none;

			white-space: nowrap;
    overflow: hidden;
    padding-right: 10px;
    text-overflow: ellipsis;
    width: 120px;
		}
	}
}

.items {
	.item {
		justify-content: flex-start;

		.ctn-profile-picture {
			width: 1.5rem;
			height: 1.5rem;
			border: none;
			margin-right: 0.5rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// CustomSelectUser.vue?aeac55dc